"use client"

import { useState } from "react"
import { SignUpHeader } from "./HeaderSignUp/SignInHeader"
import { SignUpForm } from "./SignUpForm/SignUpForm"
import {
    ButtonSignInAccount,
    ContainerSignUpPage,
    TitleSignInAccount,
    TitleSignUpPage
} from "./SignUpPageStyles.styled"
import { ModelWindow } from "../../Components/ModelWindow/ModelWindow"
import { SignInModel } from "../../Components/Public/WelcomePage/Header/SignInModel/SignInModel"
import { Footer } from "../../Components/Public/WelcomePage/Footer/Footer"
import { useLanguageContext } from "../../Components/Languages/Langs/LanguageContext"

export const SignUpPage = () => {
    const { t } = useLanguageContext();
    const [showSignIn, setShowSignIn] = useState(false);
    const [isSignInOpen, setIsSignInOpen] = useState(false);

    const openSignIn = () => {
        setShowSignIn(true);
        setTimeout(() => setIsSignInOpen(true), 0);
    };

    const closeSignIn = () => {
        setIsSignInOpen(false);
        setTimeout(() => setShowSignIn(false), 250);
    };
    return (
        <>
            <SignUpHeader />
            <ContainerSignUpPage>
                <TitleSignUpPage>{t("publicTranslate.FormsAndModel.PageSignUp.Title")} 😉</TitleSignUpPage>
            </ContainerSignUpPage>
            <SignUpForm />
            <TitleSignInAccount>
                {t("publicTranslate.FormsAndModel.PageSignUp.TitleAccount")} <ButtonSignInAccount onClick={openSignIn}>
                    {t("publicTranslate.FormsAndModel.PageSignUp.ButtonSignIn")}</ButtonSignInAccount>
            </TitleSignInAccount>
            <Footer />

            {showSignIn && (
                <ModelWindow onClose={closeSignIn} isOpen={isSignInOpen}>
                    <SignInModel onClose={closeSignIn} />
                </ModelWindow>
            )}
        </>
    )
}